import * as React from 'react';
import { useParams } from 'react-router';
import { TProductPage } from './ProductPage.types';
import { BreadcrumbsBlock } from 'components';
import { ProductDetails } from './components/ProductDetails/ProductDetails';
import './ProductPage.styled.scss';
import { useAppDispatch, useAppSelector } from 'store/store';
import { getPhoneCaseByIdAsyncThunk } from 'store/phoneCases/phoneCases.action';
import { CircularProgress } from '@mui/material';
import { TPhoneCaseBEItem } from 'api/phoneCases/phoneCases.types';
import { resetPhoneCaseById } from 'store/phoneCases/phoneCases.slices';

export const ProductPage: TProductPage = () => {
  const { productId } = useParams<{ productId: string }>();

  const dispatch = useAppDispatch();

  const {
    data: product,
    isLoading,
    error,
  } = useAppSelector((store) => store.phoneCases.phoneCaseById);

  React.useEffect(() => {
    if (productId) {
      dispatch(getPhoneCaseByIdAsyncThunk({ id: productId }));
    }

    return () => {
      dispatch(resetPhoneCaseById());
    };
  }, [productId, dispatch]);

  if (isLoading) {
    return (
      <div className="product-page">
        <div className="product-page__container">
          <div className="product-page__loading">
            <CircularProgress />
          </div>
        </div>
      </div>
    );
  }

  if (error || !product) {
    return (
      <div className="product-page">
        <div className="product-page__container">
          <h2 className="product-page__error">Товар не знайдено</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="product-page">
      <div className="product-page__container">
        <BreadcrumbsBlock
          idHelpers={[{ id: product.id, title: product.name }]}
        />
        <h1 className="product-page__title">{product.name}</h1>
        <ProductDetails product={product as TPhoneCaseBEItem} />
      </div>
    </div>
  );
};
